import styled, { keyframes } from 'styled-components';

const shimmerAnimation = keyframes`
  0% {
    background-position: -40rem 0;
  }
  100% {
    background-position: 40rem 0;
  }
`;

const SkeletonStyle = styled.div`
  border-radius: 5px;
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #e1e1e1 0%,
    #cccccc 20%,
    #e1e1e1 40%,
    #e1e1e1 100%
  );
  background-size: 80rem 14rem;
  animation: ${shimmerAnimation} 1s linear infinite forwards;
`;

export { SkeletonStyle };
